module.exports = __webpack_public_path__ + "media/images/brand/photo06-ad44d5f8bf33112fa0eecd8ddf63f0d6.png";